import React from 'react';
import { Card } from '../ui/Card';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 bg-cream" data-id="element-61">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-63">
          {/* Who it is for */}
          <Card variant="elevated" className="p-8 md:p-10 border-t-4 border-t-olive" data-id="element-64">
            <h3 className="font-heading text-2xl font-bold mb-8 text-taupe flex items-center gap-3" data-id="element-65">
              <span className="bg-olive/20 text-olive p-2 rounded-full" data-id="element-66">
                <CheckIcon className="w-6 h-6" data-id="element-67" />
              </span>
              Este método ES para ti si:
            </h3>
            <ul className="space-y-6 font-body text-taupe-light" data-id="element-68">
              <li className="flex items-start gap-4" data-id="element-69">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-70"></div>
                <p data-id="element-71">
                  Eres mujer de <strong data-id="element-72">más de 45-50 años</strong> y sientes tu
                  metabolismo "dormido".
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-73">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-74"></div>
                <p data-id="element-75">
                  Sufres de <strong data-id="element-76">inflamación abdominal persistente</strong>{' '}
                  (la famosa "panza de cortisol").
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-77">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-78"></div>
                <p data-id="element-79">
                  Duermes mal y <strong data-id="element-80">te despiertas cansada</strong>, sin
                  importar cuánto descansen.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-81">
                <div className="w-2 h-2 rounded-full bg-olive mt-2 flex-shrink-0" data-id="element-82"></div>
                <p data-id="element-83">
                  Buscas un método natural basado en{' '}
                  <strong data-id="element-84">ciencia hormonal</strong>, no en restricciones
                  extremas.
                </p>
              </li>
            </ul>
          </Card>

          {/* Who it is NOT for */}
          <Card variant="elevated" className="p-8 md:p-10 border-t-4 border-t-rose" data-id="element-85">
            <h3 className="font-heading text-2xl font-bold mb-8 text-taupe flex items-center gap-3" data-id="element-86">
              <span className="bg-rose/20 text-rose p-2 rounded-full" data-id="element-87">
                <XIcon className="w-6 h-6" data-id="element-88" />
              </span>
              Este método NO es para ti si:
            </h3>
            <ul className="space-y-6 font-body text-taupe-light" data-id="element-89">
              <li className="flex items-start gap-4" data-id="element-90">
                <div className="w-2 h-2 rounded-full bg-rose mt-2 flex-shrink-0" data-id="element-91"></div>
                <p data-id="element-92">
                  Buscas una <strong data-id="element-93">"pastilla mágica"</strong> para bajar de
                  peso en 24 horas.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-94">
                <div className="w-2 h-2 rounded-full bg-rose mt-2 flex-shrink-0" data-id="element-95"></div>
                <p data-id="element-96">
                  Prefieres <strong data-id="element-97">dietas de hambre extrema</strong> en lugar
                  de nutrición inteligente.
                </p>
              </li>
              <li className="flex items-start gap-4" data-id="element-98">
                <div className="w-2 h-2 rounded-full bg-rose mt-2 flex-shrink-0" data-id="element-99"></div>
                <p data-id="element-100">
                  No estás dispuesta a dedicar <strong data-id="element-101">10 minutos</strong> a una
                  rutina de relajación nocturna.
                </p>
              </li>
            </ul>
          </Card>
        </div>
      </div>
    </section>;
}